<template lang="pug">
v-dialog(v-model="display" persistent width="80%" class="tw-overflow-hidden")
  v-row(no-gutters align="center" justify="space-around" class="tw-bg-white tw-py-4 tw-overflow-hidden")
    v-col(cols="9")
      v-row(dense)
        v-col
          div(
            v-if="$moment(user.email_verified_at).unix() >= $moment().subtract(1, 'days').unix() && subscription == false"
            class=" text-h6 text-center"
          )
            span Your email has been verified
          div(v-if="subscription.ended_at < $moment().unix()" class="pt-4")
            v-row(align="center" justify="space-around")
              v-col(cols="auto")
                span(class="tw-text-kPurple tw-font-bold tw-text-3xl") Welcome back {{ user.name }}!
            v-row(align="center" justify="space-around" class="tw-pt-1")
              v-col(cols="7" class="tw-text-center tw-text-xl tw-leading-tight")
                span It's time to unlock the full potential Kubiqa once again. Your subscription expired on {{ $moment.unix(subscription.ended_at).format('MMMM Do YYYY') }} but it's not too late to jump back in!
      v-row(dense align="center" justify="space-around" class="")
        kubiqa-misc-pricing-grid(layout="register")
      v-row
        v-col(class="tw-pb-6")
</template>
<script>
export default {
  computed: {
    user() {
      return this.$store.getters['auth/authUser'];
    },
    subscription() {
      return this.$store.getters['team/subscription'];
    },
    display() {
      if (
        this.user &&
        (!this.subscription || (this.subscription.ended_at < this.$moment().unix() && this.subscription.ended_at))
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.getSubscription();
  },
  methods: {
    getSubscription() {
      this.$store.dispatch('team/getSubscription');
    },
  },
};
</script>
